<template>
	<div
		class="g-block-pay-jumplink-viewall"
		:class="{
			'g-block-pay-jumplink-viewall--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-viewall--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink-viewall__card">
			<div class="g-block-pay-jumplink-viewall__top">
				<div class="g-block-pay-jumplink-viewall__info">
					<p class="g-block-pay-jumplink-viewall__title">{{ data.title || '查看全部内容' }}</p>
					<p class="g-block-pay-jumplink-viewall__subtitle">{{ data.subtitle || '解锁后可永久查看' }}</p>
				</div>
				<span v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink-viewall__price">
					<span class="g-block-pay-jumplink-viewall__currency">¥</span>
					<span class="g-block-pay-jumplink-viewall__integer">{{ priceParts.integer }}</span>
					<span class="g-block-pay-jumplink-viewall__decimal">{{ priceParts.decimal }}</span>
				</span>
			</div>
			<div class="g-block-pay-jumplink-viewall__footer">
				<div class="g-block-pay-jumplink-viewall__assurance">
					<i class="mbm-iconfont mbm-iconfontanquan" :style="{ color: btnColor }"></i>
					<span>{{ data.assuranceText || '安全支付 · 自动跳转' }}</span>
				</div>
				<div
					class="g-block-pay-jumplink-viewall__btn"
					:style="buttonStyle"
					@click.stop="onButtonClick"
				>
					<span>{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '立即查看' }}</span>
					<span class="g-block-pay-jumplink-viewall__btn-arrow">
						<i class="mbm-iconfont mbm-youjiantou1" :style="{ color: btnColor }"></i>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK_VIEWALL } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkViewAll',
		mixins: [payUnlockMixin],
		computed: {
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK_VIEWALL);
			},
			buttonStyle() {
				return {
					background: this.btnColor,
					color: '#fff',
				};
			},
			priceParts() {
				const price = formatPayPrice(this.data.price ?? DEFAULT_PAY_UNLOCK_JUMPLINK_VIEWALL.price);
				const [integer, decimal = '00'] = price.split('.');
				return {
					integer,
					decimal: `.${decimal}`,
				};
			},
		},
		methods: {
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkViewAll: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-viewall {
		&--edit {
			border: 1px solid transparent;
			border-radius: 16px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-pay-jumplink-viewall__card {
		overflow: hidden;
		background: #fff;
		border-radius: 12px;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
	}

	.g-block-pay-jumplink-viewall__top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		padding: 20px 18px 16px;
	}

	.g-block-pay-jumplink-viewall__info {
		min-width: 0;
		flex: 1;
	}

	.g-block-pay-jumplink-viewall__title {
		margin: 0;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.3;
		color: #1a1a1a;
	}

	.g-block-pay-jumplink-viewall__subtitle {
		margin: 8px 0 0;
		font-size: 13px;
		line-height: 1.4;
		color: #8a8f99;
	}

	.g-block-pay-jumplink-viewall__price {
		flex-shrink: 0;
		display: inline-flex;
		align-items: flex-end;
		color: #ff2b2b;
		font-weight: 700;
		line-height: 1;
	}

	.g-block-pay-jumplink-viewall__currency {
		font-size: 16px;
		margin-right: 2px;
		margin-top: 8px;
	}

	.g-block-pay-jumplink-viewall__integer {
		font-size: 36px;
		letter-spacing: -1px;
	}

	.g-block-pay-jumplink-viewall__decimal {
		font-size: 16px;
		margin-top: 4px;
	}

	.g-block-pay-jumplink-viewall__footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		padding: 12px 14px;
		background: #f3f6fb;
	}

	.g-block-pay-jumplink-viewall__assurance {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
		flex: 1;
		font-size: 13px;
		color: #333;
		line-height: 1.3;

		.mbm-iconfont {
			flex-shrink: 0;
			font-size: 18px;
		}

		span {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.g-block-pay-jumplink-viewall__btn {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 7px 10px 7px 20px;
		border-radius: 12px;
		font-size: 14px;
		font-weight: 600;
		line-height: 1;
		cursor: pointer;
		user-select: none;
	}

	.g-block-pay-jumplink-viewall__btn-arrow {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		background: #fff;

		.mbm-iconfont {
			font-size: 18px;
		}
	}

	.g-block-pay-jumplink-viewall--h5 {
		.g-block-pay-jumplink-viewall__card {
			border-radius: 0.24rem;
			box-shadow: 0 0 0.24rem rgba(0, 0, 0, 0.1);
		}

		.g-block-pay-jumplink-viewall__top {
			gap: 0.24rem;
			padding: 0.4rem 0.36rem 0.32rem;
		}

		.g-block-pay-jumplink-viewall__title {
			font-size: 0.44rem;
		}

		.g-block-pay-jumplink-viewall__subtitle {
			margin-top: 0.16rem;
			font-size: 0.26rem;
		}

		.g-block-pay-jumplink-viewall__currency {
			font-size: 0.32rem;
			margin-top: 0.16rem;
		}

		.g-block-pay-jumplink-viewall__integer {
			font-size: 0.72rem;
		}

		.g-block-pay-jumplink-viewall__decimal {
			font-size: 0.32rem;
			margin-top: 0.08rem;
		}

		.g-block-pay-jumplink-viewall__footer {
			gap: 0.24rem;
			padding: 0.24rem 0.28rem;
		}

		.g-block-pay-jumplink-viewall__assurance {
			gap: 0.12rem;
			font-size: 0.26rem;

			.mbm-iconfont {
				font-size: 0.36rem;
			}
		}

		.g-block-pay-jumplink-viewall__btn {
			gap: 0.16rem;
			padding: 0.14rem 0.2rem .14rem 0.4rem;
			font-size: 0.28rem;
			border-radius: 0.24rem;
		}

		.g-block-pay-jumplink-viewall__btn-arrow {
			width: 0.5rem;
			height: 0.5rem;

			.mbm-iconfont {
				font-size: 0.36rem;
			}
		}
	}
</style>
